import MegaSimpleRouter from './MegaSimpleRouter';
import styles from './TestApp.module.scss';
import Home from './Home';
import Register from './Register';
import I18nProvider from './I18nProvider';

const routes = [
  {path: '/register', component: <Register/>},
  {path: '/', component: <Home/>}
];

const TestApp = () => {
  return (
    <I18nProvider>
      <div className={styles.App}>
        <div className="container py-5">
          <MegaSimpleRouter routes={routes}/>
        </div>
      </div>
    </I18nProvider>
  );
};

export default TestApp;